import React, { useMemo } from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { getAPIData, postApi, } from "../../../utils/apiFunction";
import { numberFormatwithNeg } from "../../../utils/numberFunctions";
import OystersGroup from "../../../components/OysterGroup";
import Div from "@jumbo/shared/Div";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { checkAccess } from '../../../utils/roleFunctions';
import ControlledTextField from "../../../components/ControlledTextField";
import { textfieldDateFormat } from '../../../utils/dateFunctions';

const ReceivalForm = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [completed, setCompleted] = React.useState(props.completed);
    const [updateComplete, setUpdateCompleted] = React.useState(false);
    const [edit, setEdit] = React.useState(props.edit);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [editInput, setEditInput] = React.useState(false);
    const [oystersOut, setOystersOut] = React.useState([{}]);
    const [outputsPassedGroup, setOutputsPassedGroup] = React.useState([]);
    const [stockItems, setStockItems] = React.useState(null);
    const Swal = useSwalWrapper();
    const requiredEditAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.EDIT };
    const requiredAdminAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.ADMIN };
    const CompletedAndEdit = edit && completed;
    const CompletedSoDisabled = !edit && completed;
    const supplier = props.selectedLine ? (CompletedAndEdit ? props.selectedLine.coreInventory?.receival?.supplier?.name : props.selectedLine.supplier) : '';
    const lotNbr = props.selectedLine ? (CompletedAndEdit ? props.selectedLine.coreInventory?.lotSerialNbr : props.selectedLine.lotSerialNbr) : '';
    const [comment, setComment] = React.useState(CompletedAndEdit ? props.selectedLine?.comment : null);
    const [outputQuantity, setOutputQuantity] = React.useState(null);
    const buildInitialOysters = () => {
        const line = props.selectedLine || {};
        const mgid = line.mixedGroupId || line.MixedGroupId;
        const groupItems = Array.isArray(line.groupItems) ? line.groupItems : null;
        if (mgid && groupItems && groupItems.length > 0) {
            return groupItems.map(gi => ({
                stockItemId: gi.stockItemId || gi.stockItem?.id,
                stockItem: gi.stockItem || undefined,
                quantity: Number(gi.portalQuantity ?? gi.quantity ?? 0),
                mixedGroupId: mgid,
            }));
        }
        return [{
            bags: line.bags,
            bins: line.bins,
            stockItemId: line.stockItemId,
            stockItem: line.stockItem,
            quantity: (CompletedAndEdit ? line.quantity : line.amount),
        }];
    };
    const [oystersIn, setOystersIn] = React.useState(buildInitialOysters);
    const processRunId = CompletedAndEdit ? props.selectedLine.id : props.selectedLine.processRunId

    

    React.useEffect(() => {
        getAPIData('/StockItems/GetProcessed', setStockItems);
    }, []);

    console.log(props.selectedLine);

    const getVariance = (inQuant, outQuant, perc) => {
        var totalOystersOut = outQuant;
        var diff = inQuant - totalOystersOut;
        if (perc) {
            return Math.abs((diff) / inQuant);
        } else {
            return diff;
        }
    }


    const validate = () => () => {
        var warningMessages = [];
        var errorMessages = [];
        //console.log(finished)

        const totalEntered = (oystersIn || []).reduce((p, c) => p + (Number(c.quantity) || 0), 0);
        if (Number(props.selectedLine?.amount ?? 0) < totalEntered) {
            errorMessages.push("You have entered more oysters than are available in the Inventory");
        }

        for (var i = 0; i < oystersIn.length; i++) {
            if (!Number.isFinite(Number(oystersIn[i].quantity)) || (Number(oystersIn[i].quantity) < 0)) {
                errorMessages.push("You must enter a quantity of oysters for input");
            }
            if (!(oystersIn[i].stockItem || oystersIn[i].stockItemId)) {
                errorMessages.push("You must select a stockitem for input");
            }
        }
        if (outputQuantity && (outputQuantity < 0)) {
            errorMessages.push("You must enter a quantity of oysters for output");
        }

        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {

            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    submit();
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
            });
        } else {
            submit();
        }
    }
    const submit = async () => {
        var allOk = false;
        var respArr = [];
        setLoading(true);


        const line = props.selectedLine || {};
        const mgid = line.mixedGroupId || line.MixedGroupId;
        const totalCurrent = (oystersIn || []).reduce((p, c) => p + (Number(c.quantity) || 0), 0);
        const targetTotal = Number(outputQuantity ?? totalCurrent);
        if (mgid && (oystersIn?.length || 0) > 1) {
            // Proportionally adjust each group item to match targetTotal
            // Raw shares
            const rawShares = oystersIn.map(oi => {
                const q = Number(oi.quantity) || 0;
                return totalCurrent > 0 ? (q / totalCurrent) * targetTotal : 0;
            });
            // Round preserving total
            const floors = rawShares.map(Math.floor);
            let allocated = floors.reduce((p, c) => p + c, 0);
            let remainder = Math.max(0, targetTotal - allocated);
            const remainders = rawShares.map((r, i) => ({ i, frac: r - Math.floor(r) }));
            remainders.sort((a, b) => b.frac - a.frac);
            const finalShares = [...floors];
            let idx = 0;
            while (remainder > 0 && idx < remainders.length) {
                finalShares[remainders[idx].i] += 1;
                remainder--; idx++;
            }
        for (let i = 0; i < oystersIn.length; i++) {
                const oi = oystersIn[i];
                const params = {
                    lotSerNbr: line.lotSerialNbr,
                    ExpiryDate: textfieldDateFormat(new Date(line.expiryDate)),
                    StockItemId: (oi.stockItem?.id || oi.stockItemId),
                    NewAmount: Number(finalShares[i]) || 0,
                    WarehouseId: line.warehouseId,
            OldAmount: Number(oi.quantity) || 0,
            MixedGroupId: mgid,
                };
                console.log('Adjust item', params);
                respArr.push(await postApi('/Processing/AdjustQuantity', params));
            }
        } else {
            const oi = oystersIn[0];
            const params = {
                lotSerNbr: line.lotSerialNbr,
                ExpiryDate: textfieldDateFormat(new Date(line.expiryDate)),
                StockItemId: (oi.stockItem?.id || oi.stockItemId),
                NewAmount: Number(outputQuantity ?? oi.quantity) || 0,
                WarehouseId: line.warehouseId,
                OldAmount: Number(oi.quantity) || 0,
                MixedGroupId: mgid || null,
            };
            console.log('Adjust single', params);
            respArr.push(await postApi('/Processing/AdjustQuantity', params));
        }

        if (respArr.reduce((p, c) => (p && c.ok), true)) {
            setLoading(false);
            setCompleted(true);
            setUpdateCompleted(true);
        } else {
            setError("Failed to submit");
        }

    }
    const enableInputEdit = () => {
        setEditInput(true);
    }
    const remSR = (name) => {
        if (name && name.description) {
            return name.description.replace('Sydney Rock', '');
        } else {
            return '';
        }
    }
    return (
        <Box
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1, width: '24ch' },
            }}
            noValidate
            autoComplete="off"
        >
            <Div>

                <TextField
                    disabled
                    id="outlined-required"
                    label="Supplier"
                    value={supplier}
                />
                <TextField
                    disabled
                    id="outlined-required"
                    label="Lot Nbr"
                    value={lotNbr}
                />
            </Div>
            <Div>
                {/*//comments*/}
                {/*//processing time*/}
                {/*//no of staff on line*/}

                <Grid container spacing={2} mb={1}>

                    <Grid item xs={12} >
                        <TextField
                            disabled={CompletedSoDisabled}
                            id="outlined-multiline-static"
                            label="Comment"
                            value={comment}
                            onChange={(event) => { setComment(event.target.value) }}
                            multiline
                            InputLabelProps={{
                                shrink: true,
                            }}
                            rows={4} />
                    </Grid>
                    <Grid item xs={12} >
                        {/*Icon button edit */}


                        <Typography variant={'h3'}>{"Input Stock"}</Typography>
                        <OystersGroup
                            processed={props.processed}
                            disableStockItem
                            starter={false}
                            oysters={oystersIn}
                            setOysters={setOystersIn}
                            disabled={CompletedSoDisabled}
                            single
                            noTitle
                            disableGroupPercent={!!(props.selectedLine?.mixedGroupId || props.selectedLine?.MixedGroupId)}
                            lockGroupLines={!!(props.selectedLine?.mixedGroupId || props.selectedLine?.MixedGroupId)}
                        />
                    </Grid>

                    <Grid item xs={12} >
                        <Typography variant={'h3'}>{"Output Quantity"}</Typography>
                        <ControlledTextField key={'qua'} title="Quantity (doz)" state={outputQuantity} setState={setOutputQuantity} disabled={props.disabled} number />
                    </Grid>

                    {CompletedAndEdit ?
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {/*<FormGroup>*/}
                            {/*    <FormControlLabel control={<Checkbox disabled={completed} checked={finished} onChange={(event) => {setFinished(event.target.checked);}} />} label="Process Completed" />*/}
                            {/*</FormGroup>*/}
                            <div style={{ paddingTop: '5px', textAlign: 'left' }}>
                                <SubmitButtonDisplayer title={'Update'} completed={updateComplete} error={error} loading={loading} allowed={checkAccess(props.access, requiredAdminAccess)} submitFunc={validate(false)} handleClose={props.handleClose} />
                            </div>
                        </Grid>
                        : <React.Fragment>
                            <Grid item xs={12} >
                                {(() => {
                                    const currentTotal = (oystersIn || []).reduce((p, c) => p + (Number(c.quantity) || 0), 0);
                                    const varPerc = (getVariance(currentTotal, outputQuantity, true) * 100);
                                    const varDoz = getVariance(currentTotal, outputQuantity, false);
                                    return <Typography variant={'h3'}> {"Current Variance: " + numberFormatwithNeg((varPerc)?.toFixed(0)) + '% (' + numberFormatwithNeg(varDoz) + ' doz)'}</Typography>;
                                })()}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                {/*<FormGroup>*/}
                                {/*    <FormControlLabel control={<Checkbox disabled={completed} checked={finished} onChange={(event) => {setFinished(event.target.checked);}} />} label="Process Completed" />*/}
                                {/*</FormGroup>*/}
                                <div style={{ paddingTop: '5px', textAlign: 'left' }}>
                                    <SubmitButtonDisplayer title={'Regrade'} completed={CompletedSoDisabled} error={error} loading={loading} allowed={checkAccess(props.access, requiredAdminAccess)} submitFunc={validate(false)} handleClose={props.handleClose} />
                                </div>
                            </Grid>
                        </React.Fragment>}
                </Grid>
            </Div>
        </Box >
    );
};


export default ReceivalForm;


